import React, { FC } from 'react';
import { Icons, SvgIcon } from '../../../../shared/components';
import { Description, StyledLargeButton, Title } from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';

export type AddBlockButtonLargeProps = {
  title: string;
  description: string;
  icon?: Icons;
  FAicon?: SpriteIconsLight;
  onClick: () => void;
};

const AddBlockButtonLarge: FC<AddBlockButtonLargeProps> = ({
  title,
  description,
  icon,
  onClick,
  FAicon,
}) => {
  return (
    <StyledLargeButton onClick={onClick}>
      {icon && <SvgIcon large icon={icon} />}
      {FAicon && <FontAwesomeSpriteButton icon={FAicon} iconSize="md" />}
      <Title>{title}</Title>
      <Description>{description}</Description>
    </StyledLargeButton>
  );
};

export default AddBlockButtonLarge;
